/*
 * 商品分类配置
 *
 * @Author: fan.li@zuolin.com
 * @Date: 2019-07-30 19:45:01
 * @Last Modified by: fan.li@zuolin.com
 * @Last Modified time: 2019-12-19 16:20:57
 */

const api = {
	listSections: '/section/listSections', // 获取分类列表
	addSection: '/section/addSection', // 新增分类
	deleteSection: '/section/deleteSection', // 删除分类
	updateSection: '/section/updateSection', // 更新分类
};

const routes = {
	'/commodity-classify': '商品分类',
};

export {
	api,
	routes,
};
